import { render } from "./Ventas.vue?vue&type=template&id=07d84fb4&scoped=true"
import script from "./Ventas.vue?vue&type=script&lang=js"
export * from "./Ventas.vue?vue&type=script&lang=js"

import "./Ventas.vue?vue&type=style&index=0&id=07d84fb4&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d84fb4"]])

export default __exports__